import {Observable } from 'rxjs';

import { log } from '@libs/utils';

let subscription = 0;

export function logged<T>(name: string) {
  return (source: Observable<T>): Observable<T> => {
    const prefix = `${name} ${subscription}`;
    subscription++;

    log(prefix, 'subscribed');
    return new Observable<T>((subscriber) => {
      let completed = false;

      const subscription = source.subscribe(
        (x) => {
          log(prefix, 'new item', x);
          subscriber.next(x);
        },
        (ex) => {
          log(prefix, 'error', ex);
          completed = true;
          subscriber.error(ex);
        },
        () => {
          log(prefix, 'completed');
          completed = true;
          subscriber.complete();
        }
      );

      return () => {
        if (!completed) {
          log(prefix, 'cancelled');
        }

        log(prefix, 'disposed');
        subscription.unsubscribe();
      };
    });
  };
}
